//import React components
import PropTypes from "prop-types";
import {Button, Col, Row} from "reactstrap";
import {fb_signOut} from "../../../../firebase/autentication/fb_signOut.js";
import {useNavigate} from "react-router-dom";
import MakeUserAdmin from "./SideControlAdmin.js";

//import components


//Props settings for SideControlActions
SideControlActions.propTypes = {}

SideControlActions.defaultProps = {}

export default function SideControlActions({...props}) {
    const navigate = useNavigate();
    return (
        <Row className={"sideControl_actions"}>
            <Col sm={12}>
                <Button
                    color={'danger'}
                    onClick={() => {
                        fb_signOut();
                        navigate("/login");
                    }}>
                    Logg ut
                </Button>
            </Col>
            <Col sm={12} style={{marginTop: "4rem"}}>
                <div className={"sideControl-heading"}>
                    <p className={"h5"}>Administrator Kontroll</p>
                </div>
                <div>
                    <MakeUserAdmin/>
                </div>
            </Col>
        </Row>
    )
}
